<script lang="ts">import AccordionItem from './AccordionItem/AccordionItem.svelte';
const { items = [], isFirstItemOpenByDefault = false, onClick = () => { }, summary: summaryFromProps, content: contentFromProps, class: className = '', ...rest } = $props();
function handleClick(index) {
    onClick?.(index);
}
</script>

<ul {...rest} class="Accordion {className}">
  {#each items as item, index}
    {@const { question, answer } = item}
    <li>
      <AccordionItem open={index === 0 && isFirstItemOpenByDefault} onClick={() => handleClick(index)}>
        {#snippet summary()}
          {@render summaryFromProps?.({ question })}
        {/snippet}
        {#snippet content()}
          {@render contentFromProps?.({ answer })}
        {/snippet}
      </AccordionItem>
    </li>
  {/each}
</ul>

<style>@layer design-system-components.pwds {
  .Accordion {
    margin-top: var(--space-none);
    margin-bottom: var(--space-none);
    border-bottom: var(--border-line-width) var(--border-line-style) var(--color-neutral-700);
  }
  .Accordion > li {
    padding-left: var(--space-none);
  }
  .Accordion > li > :global(*:last-child) {
    margin-bottom: var(--space-none);
  }
}</style>
